import { Link } from "react-router-dom";
import BlueButton from "../../components/buttons/BlueButton";
import ArrowUpRight from "../../components/icons/ArrowUpRight";
import ProjectCaroussel from "../../components/layout/ProjectsCaroussel";
import axios from "axios";
import { BASE_URL, decodeHtmlEntities } from "../../globals";
import { useEffect, useState } from "react";
import Loader from "../../components/assets/Loader";

export default function WorksCaroussel() {
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    async function fetchProjects() {
        setIsLoading(true);
        const post_type = "realisation";
        try {
            const response = await axios.get(`${BASE_URL}/${post_type}`);
            const data = [...response.data].map((post) => {
                return {
                    title: decodeHtmlEntities(post.title.rendered),
                    date: post.date,
                    featured_media: post.featured_media,
                    slug: post.slug
                }
            });
            for (let post of data) {
                const media = await axios.get(`${BASE_URL}/media/${post.featured_media}`);
                post.img = media.data.source_url;
            }
            setProjects(data);
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        fetchProjects();
    }, []);
    return (
        <div className="flex flex-col w-full gap-[4.375rem] items-center">
            <div className="px-5 text-balance">
                <h2 className="text-heading-3 font-[800] text-center leading-[100%] mb-3">
                    Jette un coup de <span className="text-zoeil-blue">zoeil</span> à nos réalisations
                </h2>
                <h3 className="font-[600] text-very-large text-center">
                    Tu vas tout voir en 4k parce qu’on a la vision.
                </h3>
            </div>
            {isLoading ? <Loader/>: <ProjectCaroussel
                projects={projects} />}
            <div className="mobile:w-full px-5 mobile:px-[4.5rem]">
                <Link to={"/realisations"}>
                    <BlueButton
                        icon={<ArrowUpRight />}>
                        Je veux en voir plus
                    </BlueButton>
                </Link>
            </div>
        </div>
    )
}